import api from "./api";

const normalizeUrl = (url) => url.trim();

export async function analyzePageSpeed(url, strategy = "mobile", requestOpts = {}) {
  const res = await api.get("/pagespeed/analyze", {
    params: { url: normalizeUrl(url), strategy },
    ...requestOpts,
  });
  return res.data;
}

export async function analyzePageSpeedBoth(url, requestOpts = {}) {
  const res = await api.post(
    "/pagespeed/analyze-both",
    { url: normalizeUrl(url) },
    requestOpts
  );
  return res.data;
}

export async function getSavedPageSpeed(url, requestOpts = {}) {
  const res = await api.get("/pagespeed/saved", {
    params: { url: normalizeUrl(url) },
    ...requestOpts,
  });
  return res.data;
}

export async function getSavedPageSpeedCategory(url, category, requestOpts = {}) {
  const res = await api.get("/pagespeed/saved/category", {
    params: { url: normalizeUrl(url), category },
    ...requestOpts,
  });
  return res.data;
}
